import { createEntityAdapter } from '@ngrx/entity';
import { AppletSettingFilterItemCategoryLinkContainerModel, BranchDefaultPrintableFormatHdrContainerModel } from 'blg-akaun-ts-lib';

export interface BranchSettingsState {
  selectedBranch: any;
  selectedItemCategoryFilter: AppletSettingFilterItemCategoryLinkContainerModel[];
  branchSettlementMethodList: any[];
  selectedPrintable: any;
  selectedPrintableImage: any;
  selectedPrintableImageFile: any;
  selectedPrintableImageLink: any;
  selectedDefaultFormat: BranchDefaultPrintableFormatHdrContainerModel;
  selectedEmployee: any;
  selectedEmployeeLink: any;
}

export const initialState: BranchSettingsState = {
  selectedBranch: null,
  selectedItemCategoryFilter: [],
  branchSettlementMethodList: [],
  selectedPrintable: null,
  selectedPrintableImage: null,
  selectedPrintableImageFile: null,
  selectedPrintableImageLink: null,
  selectedDefaultFormat: null,
  selectedEmployee: null,
  selectedEmployeeLink: [],
}
